import { render, staticRenderFns } from "./DriversReport.vue?vue&type=template&id=55fff22c&"
import script from "./DriversReport.vue?vue&type=script&lang=js&"
export * from "./DriversReport.vue?vue&type=script&lang=js&"
import style0 from "./DriversReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports